const Menu = [
  {
    path: '/dashboard', icon: 'solar:widget-bold-duotone', title: 'Dashboard', children: [
      { path: '/dashboard/v1', title: 'Dashboard v1' },
      { path: '/dashboard/v2', title: 'Dashboard v2' },
      { path: '/dashboard/v3', title: 'Dashboard v3' },
      { path: '/dashboard/v4', title: 'Dashboard v4' },
      { path: '/dashboard/v5', title: 'Dashboard v5', disabled: true, badge: 'coming soon' },
      { path: '/dashboard/v6', title: 'Dashboard v6', disabled: true, badge: 'coming soon' }
    ]
  },
  {
    path: '/ai', icon: 'solar:soundwave-bold-duotone', title: 'AI Studio', label: 'NEW', children: [
      { path: '/ai/chat', title: 'AI Chat' },
      { path: '/ai/image-generator', title: 'AI Image Generator' }
    ]
  },
  {
    path: '/email', icon: 'solar:inbox-line-bold-duotone', title: 'Email', badge: '10', children: [
      { path: '/email/inbox', title: 'Inbox' },
      { path: '/email/compose', title: 'Compose' },
      { path: '/email/detail', title: 'Detail' }
    ]
  },
  { path: '/widget', icon: 'solar:cpu-bolt-bold-duotone', title: 'Widgets', label: 'NEW' },
  {
    path: '/ui', icon: 'solar:palette-bold-duotone', title: 'UI Elements', label: 'NEW', children: [
      { path: '/ui/general', title: 'General', highlight: true },
      { path: '/ui/typography', title: 'Typography' },
      { path: '/ui/tabs-accordions', title: 'Tabs & Accordions' },
      { path: '/ui/unlimited-tabs', title: 'Unlimited Nav Tabs' },
      { path: '/ui/modal-notification', title: 'Modal & Notification', highlight: true },
      { path: '/ui/widget-boxes', title: 'Widget Boxes' },
      { path: '/ui/media-object', title: 'Media Object' },
      { path: '/ui/buttons', title: 'Buttons', highlight: true },
      { path: '/ui/icon-fontawesome', title: 'FontAwesome' },
      { path: '/ui/icon-bootstrap', title: 'Bootstrap Icons', highlight: true },
      { path: '/ui/icon-duotone', title: 'Duotone Icons', highlight: true },
      { path: '/ui/icon-simple-line-icons', title: 'Simple Line Icons' },
      { path: '/ui/icon-ionicons', title: 'Ionicons' },
      { path: '/ui/language-flag-icon', title: 'Language Flag Icon' },
      { path: '/ui/social-buttons', title: 'Social Buttons' }
    ]
  },
  {
    path: '/form', icon: 'solar:pen-2-bold-duotone', title: 'Form Stuff', label: 'NEW', children: [
      { path: '/form/elements', title: 'Form Elements', highlight: true },
      { path: '/form/plugins', title: 'Form Plugins', highlight: true },
      { path: '/form/wizards', title: 'Form Wizards', highlight: true }
    ]
  },
  {
    path: '/table', icon: 'solar:code-scan-bold-duotone', title: 'Tables', children: [
      { path: '/table/elements', title: 'Table Elements' },
      { path: '/table/plugins', title: 'Table Plugins' }
    ]
  },
  {
    path: '/pos', icon: 'solar:bag-smile-bold-duotone', title: 'POS System', label: 'NEW', children: [
      { path: '/pos/customer-order', title: 'Customer Order' },
      { path: '/pos/counter-checkout', title: 'Counter Checkout' },
      { path: '/pos/kitchen-order', title: 'Kitchen Order' },
      { path: '/pos/table-booking', title: 'Table Booking' },
      { path: '/pos/menu-stock', title: 'Menu Stock' }
    ]
  },
  {
    path: '/front-end', icon: 'solar:layers-bold-duotone', title: 'Front End', label: 'NEW', children: [
      { path: 'https://seantheme.com/color-admin/frontend/one-page-parallax/', title: 'One Page Parallax', external: true },
      { path: 'https://seantheme.com/color-admin/frontend/blog/', title: 'Blog', external: true },
      { path: 'https://seantheme.com/color-admin/frontend/forum/', title: 'Forum', external: true },
      { path: 'https://seantheme.com/color-admin/frontend/e-commerce/', title: 'E-Commerce', external: true },
      { path: 'https://seantheme.com/color-admin/frontend/corporate/', title: 'Corporate', external: true, highlight: true }
    ]
  },
  {
    path: '/email-template', icon: 'solar:clapperboard-text-bold-duotone', title: 'Email Template', children: [
      { path: '/email/system', title: 'System Template' },
      { path: '/email/newsletter', title: 'Newsletter Template' }
    ]
  },
  {
    path: '/chart', icon: 'solar:chart-2-bold-duotone', title: 'Charts', children: [
      { path: '/chart/js', title: 'Chart JS' },
      { path: '/chart/apex', title: 'Apex Chart' }
    ]
  },
  { path: '/map', icon: 'solar:map-point-bold-duotone', title: 'Map' },
  {
    path: '/layout', icon: 'solar:widget-4-bold-duotone', title: 'Layout', label: 'NEW', children: [
      { path: '/layout/starter', title: 'Starter Page' },
      { path: '/layout/fixed-footer', title: 'Fixed Footer', highlight: true },
      { path: '/layout/full-width', title: 'Full Width' },
      { path: '/layout/right-sidebar', title: 'Right Sidebar' },
      { path: '/layout/minified-sidebar', title: 'Minified Sidebar' },
      { path: '/layout/two-sidebar', title: 'Two Sidebar' },
      { path: '/layout/full-height', title: 'Full Height' },
      { path: '/layout/mega-menu', title: 'Mega Menu' },
      { path: '/layout/top-nav', title: 'Top Nav' },
      { path: '/layout/boxed-layout', title: 'Boxed Layout' },
      { path: '/layout/mixed-nav', title: 'Mixed Nav' },
      { path: '/layout/mixed-nav-boxed-layout', title: 'Mixed Nav Boxed Layout' },
      { path: '/layout/search-sidebar', title: 'Search Sidebar', highlight: true },
      { path: '/layout/hover-sidebar', title: 'Hover Sidebar', highlight: true }
    ]
  },
  {
    path: '/page', icon: 'solar:window-frame-bold-duotone', title: 'Pages', label: 'NEW', children: [
      { path: '/page/timeline', title: 'Timeline' },
      { path: '/page/coming-soon', title: 'Coming Soon Page' },
      { path: '/page/search-results', title: 'Search Results' },
      { path: '/page/invoice', title: 'Invoice' },
      { path: '/page/404-error', title: '404 Error Page' },
      { path: '/page/scrum-board', title: 'Scrum Board', highlight: true },
      { path: '/page/cookie-acceptance-banner', title: 'Cookie Acceptance Banner', highlight: true },
      { path: '/page/orders', title: 'Orders', highlight: true },
      { path: '/page/order-details', title: 'Order Details', highlight: true },
      { path: '/page/products', title: 'Products', highlight: true },
      { path: '/page/product-details', title: 'Product Details', highlight: true },
      { path: '/page/file-manager', title: 'File Manager', highlight: true },
      { path: '/page/pricing-page', title: 'Pricing Page', highlight: true },
      { path: '/page/messenger-page', title: 'Messenger Page', highlight: true },
      { path: '/page/data-management', title: 'Data Management', highlight: true },
      { path: '/page/gallery', title: 'Gallery', highlight: true }
    ]
  },
  {
    path: '/auth', icon: 'solar:lock-keyhole-bold-duotone', title: 'Authentication', children: [
      {
        path: '/auth/classic', title: 'Classic', children: [
          { path: '/auth/classic/sign-in', title: 'Sign In' },
          { path: '/auth/classic/sign-up', title: 'Sign Up' },
          { path: '/auth/classic/reset-password', title: 'Reset Password' },
          { path: '/auth/classic/new-password', title: 'New Password' },
          { path: '/auth/classic/lock-screen', title: 'Lock Screen' },
          { path: '/auth/classic/email-sent', title: 'Email Sent' }
        ]
      },
      {
        path: '/auth/with-box', title: 'With Box', children: [
          { path: '/auth/with-box/sign-in', title: 'Sign In' },
          { path: '/auth/with-box/sign-up', title: 'Sign Up' },
          { path: '/auth/with-box/reset-password', title: 'Reset Password' },
          { path: '/auth/with-box/new-password', title: 'New Password' },
          { path: '/auth/with-box/lock-screen', title: 'Lock Screen' },
          { path: '/auth/with-box/email-sent', title: 'Email Sent' }
        ]
      },
      {
        path: '/auth/with-image', title: 'With Image', children: [
          { path: '/auth/with-image/sign-in', title: 'Sign In' },
          { path: '/auth/with-image/sign-up', title: 'Sign Up' },
          { path: '/auth/with-image/reset-password', title: 'Reset Password' },
          { path: '/auth/with-image/new-password', title: 'New Password' },
          { path: '/auth/with-image/lock-screen', title: 'Lock Screen' },
          { path: '/auth/with-image/email-sent', title: 'Email Sent' }
        ]
      },
      {
        path: '/auth/full-screen', title: 'Full Screen', children: [
          { path: '/auth/full-screen/sign-in', title: 'Sign In' },
          { path: '/auth/full-screen/sign-up', title: 'Sign Up' },
          { path: '/auth/full-screen/reset-password', title: 'Reset Password' },
          { path: '/auth/full-screen/new-password', title: 'New Password' },
          { path: '/auth/full-screen/lock-screen', title: 'Lock Screen' },
          { path: '/auth/full-screen/email-sent', title: 'Email Sent' }
        ]
      },
      {
        path: '/auth/cover-bg', title: 'Cover Background', children: [
          { path: '/auth/cover-bg/sign-in', title: 'Sign In' },
          { path: '/auth/cover-bg/sign-up', title: 'Sign Up' },
          { path: '/auth/cover-bg/reset-password', title: 'Reset Password' },
          { path: '/auth/cover-bg/new-password', title: 'New Password' },
          { path: '/auth/cover-bg/lock-screen', title: 'Lock Screen' },
          { path: '/auth/cover-bg/email-sent', title: 'Email Sent' }
        ]
      }
    ]
  },
  { path: '/landing', icon: 'solar:crown-bold-duotone', title: 'Landing Page', label: 'NEW' },
  { path: '/users', title: 'Users', menuHeader: true },
  { path: '/profile', icon: 'solar:user-bold-duotone', title: 'Profile' },
  { path: '/calendar', icon: 'solar:calendar-bold-duotone', title: 'Calendar' },
  { path: '/settings', icon: 'solar:settings-bold-duotone', title: 'Settings' },
  { path: '/helper', icon: 'solar:help-bold-duotone', title: 'Helper' },
  {
    path: '/menu', icon: 'solar:list-bold-duotone', title: 'Menu Level', children: [
      { path: '/menu/menu-1-1', title: 'Menu 1.1', children: [
        { path: '/menu/menu-1-1/menu-2-1', title: 'Menu 2.1', children: [
          { path: '/menu/menu-1-1/menu-2-1/menu-3-1', title: 'Menu 3.1' },
          { path: '/menu/menu-1-1/menu-2-1/menu-3-2', title: 'Menu 3.2' }
        ] },
        { path: '/menu/menu-1-1/menu-2-2', title: 'Menu 2.2' },
        { path: '/menu/menu-1-1/menu-2-3', title: 'Menu 2.3' }
      ] },
      { path: '/menu/menu-1-2', title: 'Menu 1.2' },
      { path: '/menu/menu-1-3', title: 'Menu 1.3' }
    ]
  }
];

export default Menu;
